module.exports = __webpack_public_path__ + "img/sysbar-bg.e37ee861.jpg";